/**
 * Etykiety list trzymamy jako klucze tłumaczeń (`labelKey`), ale definicje mogą wciąż podawać
 * gotowy tekst (`label`). Gdy klucza nie ma w bazie, `translateEntry` zwraca jego kod — wtedy
 * schodzimy do tekstu z definicji, żeby w interfejsie nie pojawił się surowy `T_...`.
 */
export const resolveLabel = (translateEntry, labelKey, fallback = '') => {
  if (!labelKey) return fallback

  const translated = translateEntry(labelKey)

  return !translated || translated === labelKey ? fallback : translated
}
